// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__fQeZS","avatar":"styles_avatar__2tEbs","name":"styles_name__1b7pa"};